"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function NumberQuestionTypeSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 54, height: 32, viewBox: "0 0 54 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("rect", { opacity: 0.1, y: 8, width: 54, height: 14, rx: 2, fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.4, x: 6.00781, y: 14.5, width: 2, height: 2, fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.4, x: 10.0078, y: 14.5, width: 2, height: 2, fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.4, x: 14.0078, y: 14.5, width: 2, height: 2, fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.4, x: 18.0078, y: 14.5, width: 2, height: 2, fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.4, x: 22.0078, y: 14.5, width: 2, height: 2, fill: "#597EFF" }),
        react_1.default.createElement("rect", { opacity: 0.4, x: 26.0078, y: 14.5, width: 2, height: 2, fill: "#597EFF" }),
        react_1.default.createElement("path", { d: "M42.8168 25H39.7768L41.6328 19.56H38.5928L36.7688 25H33.7608L35.5848 19.56H32.5128L33.3448 16.968H36.4808L38.2088 11.688H35.1048L35.9048 9.128H39.1048L40.8968 3.656H43.9048L42.1128 9.128H45.1208L46.9128 3.656H49.9528L48.0968 9.128H51.2008L50.4648 11.688H47.2328L45.4728 16.968H48.7048L47.9048 19.56H44.6088L42.8168 25ZM42.4648 16.968L44.2248 11.688H41.2168L39.4888 16.968H42.4648Z", fill: "#597EFF", fillOpacity: 0.4 }));
}
function NumberQuestionType(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(NumberQuestionTypeSvg, Object.assign({}, svgProps)));
}
exports.default = NumberQuestionType;
//# sourceMappingURL=NumberQuestionType.js.map